/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'
import moment from 'jalali-moment'

export default function index(data) {
  const [category, setCategory] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCategory(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>سفارش دهنده</th>
            <th>شماره موبایل سفارش دهده</th>
            <th>آیدی پیک</th>
            <th>تاریخ سفارش</th>
            <th>وضعیت پرداخت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {category ? category.map(item => (
              <tr key={item._id}>
                <td>{item.user[0].name}</td>
                <td>0{item.user[0].phoneNumber}</td>
                <td>{item.deliverUser}</td>
                <td>{moment(item.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</td>
                <td>{item.payStatus === true ? (
                  <span className='success'>پرداخت شده</span>
                ) : (
                  <sapn className='failed'>پرداخت نشده</sapn>
                )}</td>
                <td>
                  <button onClick={() => navigate(`/peyk/peyks/edit/${item._id}`)}>مشاهده</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
